import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../ui/dialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DecisionEmailDialog = ({ app, status, onClose, onConfirm }) => {
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!status) return;
    setPreview(null);
    axios.get(`${API}/preceptorship/${app.id}/decision-email`, { params: { status }, withCredentials: true })
      .then((res) => setPreview(res.data))
      .catch(() => setPreview({ error: true }));
  }, [app.id, status]);

  const confirm = async (sendEmail) => {
    setBusy(true);
    await onConfirm(app.id, status, sendEmail);
    setBusy(false);
    onClose();
  };

  const label = status === 'approved' ? 'Approved' : 'Declined';
  return (
    <Dialog open={!!status} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="decision-email-dialog">
        <DialogHeader>
          <DialogTitle>Mark as {label} and email the student?</DialogTitle>
          <DialogDescription>Review the email below before it is sent.</DialogDescription>
        </DialogHeader>
        {!preview && <p className="text-gray-500">Loading email preview…</p>}
        {preview?.error && <p className="text-red-700">Could not load the email preview.</p>}
        {preview && !preview.error && (
          <div className="border border-gray-200 rounded-lg p-4 bg-gray-50 text-sm space-y-2 max-h-80 overflow-y-auto" data-testid="decision-email-preview">
            <p><span className="font-semibold">To:</span> {preview.to}</p>
            <p><span className="font-semibold">Subject:</span> {preview.subject}</p>
            <p className="whitespace-pre-line text-gray-800 pt-2 border-t border-gray-200">{preview.text}</p>
          </div>
        )}
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <button onClick={onClose} disabled={busy} data-testid="decision-cancel-btn"
            className="px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors">Cancel</button>
          <button onClick={() => confirm(false)} disabled={busy} data-testid="decision-no-email-btn"
            className="px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors">Mark {label} without email</button>
          <button onClick={() => confirm(true)} disabled={busy || !preview || preview.error} data-testid="decision-send-email-btn"
            className="px-4 py-2 rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700 transition-colors disabled:opacity-50">
            {busy ? 'Sending…' : `Send Email & Mark ${label}`}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
